import { EmailSettingsComponent } from './email-settings/email-settings.component'
import { SecuritySettingsComponent } from './security-settings/security-settings.component'
import { GisSettingsComponent } from './gis-settings/gis-settings.component'
import { FilesystemSettingsComponent } from './filesystem-settings/filesystem-settings.component'
import { GeneralSettingsComponent } from './general-settings/general-settings.component'
import { SettingsComponent } from './settings.component'
import { MainLayoutComponent } from '@components/main-layout/main-layout.component'
import { Routes } from '@angular/router'
import { AuthGuard } from 'src/app/guards/auth.guard'
import { NgxPermissionsGuard } from 'ngx-permissions'

export const settingsRoutes: Routes = [
  {
    path: 'admin/settings',
    component: MainLayoutComponent,
    canActivate: [AuthGuard, NgxPermissionsGuard],
    data: {
      permissions: {
        only: 'SYSTEM_SETTINGS',
        redirectTo: '/',
      },
    },
    children: [
      {
        path: '',
        component: SettingsComponent,
        children: [
          {
            path: '',
            redirectTo: 'general',
            pathMatch: 'full',
          },
          {
            path: 'general',
            component: GeneralSettingsComponent,
          },
          {
            path: 'gis',
            component: GisSettingsComponent,
          },
          {
            path: 'email',
            component: EmailSettingsComponent,
          },
          {
            path: 'filesystem',
            component: FilesystemSettingsComponent,
          },
          {
            path: 'security',
            component: SecuritySettingsComponent,
          },
        ],
      },
    ],
  },
]
